import React,{useState,useEffect,useRef} from 'react'
import styled from 'styled-components'
import audioFile from '../assets/exalted-christian-band_exalted-christian-band-snippets-2018.mp3'
import VideoSlider from './VideoSlider'
import AudioPlayer from './ui/AudioPlayer'



export default ()=>{

    const [width,setConWidth] = useState(0)
    
    const audioRef = useRef(null)


        

        


    useEffect(()=>{ 
        setConWidth(
            window.innerWidth/2 > 400 ? window.innerWidth/2 : window.innerWidth - document.getElementById('side-bar').offsetWidth
        )
        window.addEventListener('resize',e=>{
            setConWidth(
                window.innerWidth/2 > 400 ? window.innerWidth/2 : window.innerWidth - document.getElementById('side-bar').offsetWidth
            )
        })
    },[])

    


    const H2 = styled.h2`
        font-size:4rem;
        text-align:center;
        margin-bottom:4rem;
        margin-top:2rem;
    `
    const H3 = styled.h3`
        font-size:1.5rem;
        text-align:center;
        font-weight:700;
        
    `
    const AudioContainer = styled.div`
        width:${width}px;
        background:rgb(40,40,40);
        color:rgba(220,220,220);
        margin:0rem auto;
        margin-bottom:4rem;
        border-top-left-radius:3px;
        border-top-right-radius:3px;
        overflow:hidden;
        box-shadow:2px 2px 8px black;

        & p{
            margin-top:-1rem;
            color:rgba(170,170,170)
        }
    `

    return(
        <React.Fragment>
            <H2>Music</H2>

            <AudioContainer >
                <H3>Exalted Band Highlights</H3>
                <p>Here is a sample of our music.</p>
                <div ref={audioRef} style={{display:'block',margin:'auto',width:width+'px'}}>
                    <AudioPlayer link={audioFile}></AudioPlayer>
                </div>
                
            </AudioContainer>

            <VideoSlider>
            </VideoSlider>

        </React.Fragment>
    )
}